export default __webpack_public_path__ + "static/media/reviro.000693e2.svg";